import {Trans} from "@lingui/react/macro";
import {registerSW} from "virtual:pwa-register";
import {addMessage} from "./features/messenger/messenger";
import Button from "./ui/Button";
import {registerPeriodicSync} from "./utils/periodic-sync";

registerSW({
  onOfflineReady: () => {
    // eslint-disable-next-line no-console
    console.log("can be used offline");
  },
  onRegisteredSW: () => {
    registerPeriodicSync().catch((e: unknown) => console.warn("periodic sync not registered", e));
  },
});

// sw.ts skips waiting on its own, so a fetched update takes over quickly. Wait for that before
// reloading, otherwise the reload may still be served by the old version.
const reloadWithLatestVersion = async () => {
  const registration =
    "serviceWorker" in navigator
      ? await navigator.serviceWorker.getRegistration().catch(() => undefined)
      : undefined;
  if (registration) {
    await registration.update().catch(() => undefined);
    const pending = registration.installing ?? registration.waiting;
    if (pending) {
      pending.postMessage({type: "SKIP_WAITING"});
      await new Promise<void>((res) => {
        navigator.serviceWorker.addEventListener("controllerchange", () => res(), {once: true});
        setTimeout(res, 5000);
      });
    }
  }
  location.reload();
};

export const onNewerDataVersion = () => {
  addMessage(
    <div>
      <Trans>This list was updated by a newer version of the app. Reload to keep syncing.</Trans>
      <Button onClick={reloadWithLatestVersion}>
        <Trans>Reload</Trans>
      </Button>
    </div>,
    {durationMs: Infinity}
  );
};
